<template>
	<div>
		<fab
			:main-icon="fab.icon"
			:position="fab.position"
			:bg-color="fab.bgColor"
			:actions="fab.fabActions"
			:fixed-tooltip="fab.tooltip"
			@add="add"
			@visibility="visibility"
			@edit="edit">
		</fab>

		<add ref="add" :user="user" :isAuth="isAuth" :item="item" @reload="reload"></add>
	</div>
</template>

<script>
	import fab from 'vue-fab'
	import Add from './Add'

	export default {
		props: ['user', 'isAuth', 'item', 'type'],
		components: {
			fab,
			'add': Add,
		},
		created() {
			this.init()
		},
		data () {
			return {
				fab: {
					icon: 'reorder',
					bgColor: '#1cb9f2',
					position: 'bottom-right',
					fabActions: null,
					tooltip: true,
				}
			}
		},
		watch: {
			type() {
				this.loadActions()
			},
		},
		methods: {
			init() {
				this.loadActions()
			},
			loadActions() {
				if(this.type == 'standar') {
					var actions = [
						{
							tooltip: 'Ver',
							name: 'visibility',
							icon: 'visibility',
						},
						{
							tooltip: 'Editar',
							name: 'edit',
							icon: 'mode_edit',
						},
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
					]
				}
				if(this.type == 'show') {
					var actions = [
						{
							tooltip: 'Editar',
							name: 'edit',
							icon: 'mode_edit',
						},
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
					]
				}
				if(this.type == 'edit') {
					var actions = [
						{
							tooltip: 'Ver',
							name: 'visibility',
							icon: 'visibility',
						},
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
					]
				}
				if(this.type == 'index') {
					var actions = [
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
					]
				}

				this.fab.fabActions = actions
			},
			add() {
				if(this.type == 'index') {
					this.$refs.add.openCreate()
				} else {
					this.$refs.add.open()
				}
			},
			edit() {
				this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/projects/projects/' + this.item.id + '/edit')
			},
			visibility() {
				this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/projects/projects/' + this.item.id)
			},
			reload() {
				this.$emit('reload')
			},
			//--
			openCreateSchedule(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open()
			},
			openTaskCreate(data) {
				this.$refs.taskCreate.open(data)
			},
			//--
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Fab.vue